import { DoctorsViewAction, DoctorsViewState } from './doctors.view.types'

export const doctorsViewParamsSetAction = (params: Partial<DoctorsViewState>): DoctorsViewAction => ({ type: 'DOCTORS_VIEW_PARAMS_SET', params })